// Shared helpers used by bond-form `validateStepData` callbacks across
// the four bond types. Extracted to remove repeated cognitive complexity.

// Walk a dotted path through the data tree and return whether it is missing.
const isMissingAtPath = (data, path) => {
  const parts = path.split(".");
  let cur = data;
  for (const part of parts) {
    const value = cur?.[part];
    if (value === undefined || value === "" || value === null) {
      return true;
    }
    cur = value;
  }
  return false;
};

// Run "required field" presence validation on a list of dotted paths.
export const validateRequiredPaths = (data, requiredFields) => {
  const errs = {};
  requiredFields.forEach((path) => {
    if (isMissingAtPath(data, path)) {
      errs[path] = "This field is required";
    }
  });
  return errs;
};

// Append `guardians.<i>.<field>` paths for each guardian and each dynamic field.
export const appendGuardianRequiredPaths = (requiredFields, count, dynamicGuardianFields) => {
  for (let i = 0; i < count; i++) {
    dynamicGuardianFields.forEach((field) => {
      requiredFields.push(`guardians.${i}.${field}`);
    });
  }
};

// Validate occupation fields for high-bond-amount principals.
// `splitEmployment` is `splitEmploymentOccupation` from the bond-type shared helpers.
export const validateOccupationForHighBond = (data, count, splitEmployment, occupationKey = "occupation") => {
  const errs = {};
  const guardians = Array.isArray(data?.guardians) ? data.guardians : [];
  for (let i = 0; i < count; i++) {
    const g = guardians[i] || {};
    if (g.is_professional_guardian === "Yes" || g.is_attorney === "Yes") continue;
    const { employmentStatus, occupationText } = splitEmployment(g[occupationKey]);
    const errorPath = `guardians.${i}.${occupationKey}`;
    if (!employmentStatus) {
      errs[errorPath] = "Employment Status is required";
      continue;
    }
    if ((employmentStatus === "Employed" || employmentStatus === "Retired") && !occupationText) {
      errs[errorPath] =
        employmentStatus === "Retired"
          ? "What occupation did you retire from? is required"
          : "What is your current occupation? is required";
    }
  }
  return errs;
};

export const HIGH_BOND_AMOUNT_THRESHOLD = 250000;

/** Underwriting authorization threshold; Guardian - Minor uses a lower floor. */
export const getUnderwritingThreshold = (bondSubCategory) =>
  bondSubCategory === "Guardian - Minor" ? 50000 : 250000;
